export default __webpack_public_path__ + "static/media/training.fe3565b0.JPG";